import React, { Component } from 'react'
import K from '../../services/k'
import Axios from 'axios'
import MultiSelect from 'multiselect-react-dropdown'
import swal from 'sweetalert'
export class WorkDetails extends Component {
  state = {
    isLoading: false,
    isIndependentAgreementCheck1: false,
    isIndependentAgreementCheck2: false,
    msg: '',
    errors: {},
    fields: {},
  }

  handleChange = (field, e) => {
    this.setFieldItem(field, e.target.value)
  }

  handleisIndependentAgreementCheck1 = (value) => {
    this.setState({ isIndependentAgreementCheck1: value })
  }
  handleisIndependentAgreementCheck2 = (value) => {
    this.setState({ isIndependentAgreementCheck2: value })
  }
  alertAgreement = (e) => {
    e.preventDefault()
    swal({
      title: 'Alert',
      text: `Please Agree to Our Terms of Service`,
      icon: 'warning',
      timer: null,
      closeOnClickOutside: false,
    })
  }

  handleValidation = () => {
    let fields = this.state.fields
    let errors = {}
    let formIsValid = true

    //Name
    if (!fields['first_name']) {
      formIsValid = false
      errors['first_name'] = 'first name not be empty'
    }

    // if (!fields["middle_name"]) {
    //   formIsValid = false;
    //   errors["middle_name"] = "middle_name Cannot be empty";
    // }

    if (!fields['last_name']) {
      formIsValid = false
      errors['last_name'] = 'last name Cannot be empty'
    }
    if (!fields['street_address']) {
      formIsValid = false
      errors['street_address'] = 'street address Cannot be empty'
    }
    if (!fields['phone']) {
      formIsValid = false
      errors['phone'] = 'phone Cannot be empty'
    }
    if (!fields['dob']) {
      formIsValid = false
      errors['dob'] = 'dob Cannot be empty'
    }
    if (!fields['gender']) {
      formIsValid = false
      errors['gender'] = 'Gender cannot be empty'
    }
    if (!fields['license_number']) {
      formIsValid = false
      errors['license_number'] = 'license number Cannot be empty'
    }
    if (!fields['license_expiry']) {
      formIsValid = false
      errors['license_expiry'] = 'license expiry Cannot be empty'
    }
    if (!fields['license_plate_number']) {
      formIsValid = false
      errors['license_plate_number'] = 'license plate number Cannot be empty'
    }
    if (!fields['courier_history']) {
      formIsValid = false
      errors['courier_history'] = 'courier hsitory cannot be empty'
    }
    // if (!fields["courier"]) {
    //   formIsValid = false;
    //   errors["courier"] = "courier license flag is required"
    // }
    if (!fields['has_insurance']) {
      formIsValid = false
      errors['has_insurance'] = 'Insurance flag is required'
    }
    if (!fields['is_ends']) {
      formIsValid = false
      errors['is_ends'] = 'ENDS flag is required'
    }
    // if (!fields["weekly_availability"]) {
    //   formIsValid = false;
    //   errors["weekly_availability"] = "weekly availability Cannot be empty";
    // }
    if (!fields['start_time']) {
      formIsValid = false
      errors['start_time'] = 'start time Cannot be empty'
    }
    if (!fields['has_smart_phone']) {
      formIsValid = false
      errors['has_smart_phone'] = 'Smartphone Flag is required'
    }
    if (!fields['smart_phone_type']) {
      formIsValid = false
      errors['smart_phone_type'] = 'smart phone type Cannot be empty'
    }
    // if (!fields["reference_name"]) {
    //   formIsValid = false;
    //   errors["reference_name"] = "reference name Cannot be empty";
    // }
    // if (!fields["reference_phone"]) {
    //   formIsValid = false;
    //   errors["reference_phone"] = "reference phone Cannot be empty";
    // }
    if (!fields['emergency_contact_name']) {
      formIsValid = false
      errors['emergency_contact_name'] =
        'emergency contact name Cannot be empty'
    }
    if (!fields['emergency_contact_phone']) {
      formIsValid = false
      errors['emergency_contact_phone'] =
        'emergency contact phone Cannot be empty'
    }
    if (!fields['vehicle_type']) {
      formIsValid = false
      errors['vehicle_type'] = 'vehicle type Cannot be empty'
    }
    // if (!fields["vehicle_type_secondary"]) {
    //   formIsValid = false;
    //   errors["vehicle_type_secondary"] =
    //     "vehicle type secondary Cannot be empty";
    // }
    if (!fields['involved_in_crime']) {
      formIsValid = false
      errors['involved_in_crime'] = 'Crime flag is required'
    }
    if (!fields['use_online_banking']) {
      formIsValid = false
      errors['use_online_banking'] = 'Online Banking Flag is required'
    }
    if (!fields['has_bill_express_account']) {
      formIsValid = false
      errors['has_bill_express_account'] =
        'Bill express account flag is required '
    }
    // if (!fields["has_involved_in_trafic_infraction"]) {
    //   formIsValid = false;
    //   errors["has_involved_in_trafic_infraction"] =
    //     "Involved in traffic infraction flag is required ";
    // }
    // if (!fields["driving_period"]) {
    //   formIsValid = false;
    //   errors["driving_period"] = "Driving period Cannot be empty";
    // }

    this.setState({ errors: errors })
    return formIsValid
  }
  continue = (e) => {
    e.preventDefault()
    if (this.handleValidation()) {
      this.props.confirmDataState(this.state.fields)
      this.props.nextStep()
    } else {
      let errors = this.state.errors
      let formErrors = []

      formErrors = Object.keys(errors).map((error) => {
        return `${errors[error]}`
      })

      swal({
        title: 'All Fields Are Required!',
        text: `${formErrors.map((err) => `${err}  \n`)}`,
        icon: 'warning',
        timer: null,
        closeOnClickOutside: false,
      })
    }
  }

  back = (e) => {
    e.preventDefault()
    this.props.prevStep()
  }

  componentDidMount = async () => {
    this.setState({ isLoading: true })

    let rider_email = localStorage.getItem('rider_email')
    let rider_pwd = localStorage.getItem('rider_pwd')

    let data = {
      email: rider_email,
      password: rider_pwd,
    }

    await Axios.post(K.riderLogin, data, { 'Content-type': 'application/json' })
      .then((response) => {
        if (
          response &&
          response.message &&
          response.message.indexOf('log in') > -1
        ) {
          this.props.logOut()
          return
        }
        let { data } = response.data
        localStorage.setItem('rider_id', data.id)
        localStorage.setItem('rider_email', data.email)
        localStorage.setItem('rider_api_token', data.api_token)

        this.setState({ isLoading: false })
      })
      .catch((error) => {
        console.log(error)
        this.setState({ msg: 'Un Expected Error Occured' })
        this.setState({ isLoading: false })
      })
  }

  setFieldItem = (key, value) => {
    this.setState((prevState) => ({
      fields: {
        ...prevState.fields,
        [key]: value,
      },
    }))
  }

  workdays_setSelected = (selected) => {
    this.setFieldItem('workdays_selected', selected)
  }

  workhours_setSelected = (selected) => {
    this.setFieldItem('workhours_selected', selected)
  }

  render() {
    const workdays_options = [
      { label: 'Monday', key: 'Monday' },
      { label: 'Tuesday', key: 'Tuesday' },
      { label: 'Wednesday', key: 'Wednesday' },
      { label: 'Thursday', key: 'Thursday' },
      { label: 'Friday', key: 'Friday' },
      { label: 'Saturday', key: 'Saturday' },
      { label: 'Sunday', key: 'Sunday' },
    ]
    const workhours_options = [
      { label: 'morning hours', key: 'morning hours' },
      { label: 'afternoon hours', key: 'afternoon hours' },
      { label: 'evening hours', key: 'evening hours' },
    ]
    return (
      <>
        <div className="main-wrapper inner--page rider-page">
          <section
            className="hero-banner inner-banner form-page"
            style={{ backgroundImage: `url('images/rider-banner.png')` }}
          >
            <div className="container">
              <div className="row pt-100">
                <div className="col-lg-10 offset-lg-1 col-md-10 offset-md-1">
                  <div className="partner-form">
                    <div className="heading-text border-bottom">
                      <h3>Update Profile Details (WorkDetails)</h3>
                      <p>Provide more information below</p>
                    </div>
                    {this.state.isLoading ? (
                      <span>
                        <p className="text-spinner-font text-center">
                          <i className="fa fa-spinner fa-spin spinner-font"></i>
                          &nbsp;Please Wait...
                        </p>
                      </span>
                    ) : (
                      <form>
                        <div className="row">
                          <div className="col-lg-6">
                            <div className="form-group">
                              <label>First Name</label>
                              <input
                                type="text"
                                name="first_name"
                                placeholder="First name"
                                onChange={this.handleChange.bind(
                                  this,
                                  'first_name',
                                )}
                                value={this.state.fields['first_name']}
                                // required
                              />
                            </div>
                          </div>
                          <div className="col-lg-6">
                            <div className="form-group">
                              <label>Middle Name</label>
                              <input
                                type="text"
                                name="middle_name"
                                placeholder="Middle name"
                                onChange={this.handleChange.bind(
                                  this,
                                  'middle_name',
                                )}
                                value={this.state.fields['middle_name'] ?? ''}
                                // required
                              />
                            </div>
                          </div>
                          <div className="col-lg-6">
                            <div className="form-group">
                              <label>Last Name</label>
                              <input
                                type="text"
                                name="last_name"
                                placeholder="Last name"
                                onChange={this.handleChange.bind(
                                  this,
                                  'last_name',
                                )}
                                value={this.state.fields['last_name']}
                                // required
                              />
                            </div>
                          </div>
                          <div className="col-lg-6">
                            <div className="form-group">
                              <label>Street Address</label>
                              <input
                                type="text"
                                name="street_address"
                                placeholder="Street address"
                                onChange={this.handleChange.bind(
                                  this,
                                  'street_address',
                                )}
                                value={this.state.fields['street_address']}
                                // required
                              />
                            </div>
                          </div>
                          <div className="col-lg-6">
                            <label>Parish</label>
                            <div className="form-group">
                              <select
                                name="parish"
                                onChange={this.handleChange.bind(
                                  this,
                                  'parish',
                                )}
                                value={this.state.fields['parish']}
                                className="form-select form-select-lg mb-3"
                                aria-label=".form-select-lg example"
                                // required
                              >
                                <option selected>Select Parish</option>
                                <option value="Claredon">Clarendon</option>
                                <option value="Hanover">Hanover</option>
                                <option value="Kingston">Kingston</option>
                                <option value="Manchester">Manchester</option>
                                <option value="Portland">Portland</option>
                                <option value="St Andrew">St Andrew</option>
                                <option value="St Ann">St Ann</option>
                                <option value="St Catherine">
                                  St Catherine
                                </option>
                                <option value="St Elizabeth">
                                  St Elizabeth
                                </option>
                                <option value="St James">St James</option>
                                <option value="St Mary">St Mary</option>
                                <option value="St Thomas">St Thomas</option>
                                <option value="Trelawney">Trelawney</option>
                                <option value="Westmoreland">
                                  Westmoreland
                                </option>
                              </select>
                            </div>
                          </div>
                          <div className="col-lg-6">
                            <div className="form-group">
                              <label>Phone number</label>
                              <input
                                type="text"
                                name="phone"
                                placeholder="Phone number"
                                onChange={this.handleChange.bind(this, 'phone')}
                                value={this.state.fields['phone']}
                                // required
                              />
                            </div>
                          </div>
                          <div className="col-lg-6">
                            <div className="form-group">
                              <label>Date Of Birth</label>
                              <input
                                type="date"
                                name="dob"
                                placeholder="Date of birth"
                                onChange={this.handleChange.bind(this, 'dob')}
                                value={this.state.fields['dob']}
                                // required
                              />
                            </div>
                          </div>
                          <div className="col-lg-6">
                            <div className="form-group">
                              <label>Gender</label>
                              <select
                                name="gender *"
                                onChange={this.handleChange.bind(
                                  this,
                                  'gender',
                                )}
                                value={this.state.fields['gender']}
                                className="form-select form-select-lg mb-3"
                                aria-label=".form-select-lg example"
                                // required
                              >
                                <option selected>Select Gender</option>
                                <option value="Male">Male</option>
                                <option value="Female">Female </option>
                                <option value="other">other </option>
                              </select>
                            </div>
                          </div>
                          <div className="col-lg-6">
                            <div className="form-group">
                              <label>Courier History</label>
                              <select
                                name="courier_history"
                                onChange={this.handleChange.bind(
                                  this,
                                  'courier_history',
                                )}
                                value={this.state.fields['courier_history']}
                                className="form-select form-select-lg mb-3"
                                aria-label=".form-select-lg example"
                                // required
                              >
                                <option selected>Select Courier History</option>
                                <option value="currently not employed">
                                  I have never been employed as a courier driver
                                </option>
                                <option value="have diver but not mployed">
                                  I have courier driver experience but not
                                  currently employed
                                </option>
                                <option value="currently employed">
                                  I am currently employed as a courier driver{' '}
                                </option>
                              </select>
                            </div>
                          </div>
                          <div className="col-lg-6">
                            <div className="form-group">
                              <label>Drivers License Number</label>
                              <input
                                type="text"
                                name="license_number"
                                placeholder="Drivers License number"
                                onChange={this.handleChange.bind(
                                  this,
                                  'license_number',
                                )}
                                value={this.state.fields['license_number']}
                                // required
                              />
                            </div>
                          </div>
                          <div className="col-lg-6">
                            <div className="form-group">
                              <label>Lisence Expiry Date</label>
                              <input
                                type="date"
                                name="license_expiry"
                                placeholder="License expiry"
                                onChange={this.handleChange.bind(
                                  this,
                                  'license_expiry',
                                )}
                                value={this.state.fields['license_expiry']}
                                // required
                              />
                            </div>
                          </div>
                          <div className="col-lg-6">
                            <div className="form-group">
                              <label>License Plate Number</label>
                              <input
                                type="text"
                                name="license_plate_number"
                                placeholder="License plate number"
                                onChange={this.handleChange.bind(
                                  this,
                                  'license_plate_number',
                                )}
                                value={
                                  this.state.fields['license_plate_number']
                                }
                                // required
                              />
                            </div>
                          </div>
                          <div className="col-lg-6">
                            <div className="form-group">
                              <label>Do you have a couriers license?</label>
                              <select
                                name="courier"
                                onChange={this.handleChange.bind(
                                  this,
                                  'courier',
                                )}
                                value={this.state.fields['courier']}
                                className="form-select form-select-lg mb-3"
                                aria-label=".form-select-lg example"
                                // required
                              >
                                <option selected>Select Flag</option>
                                <option value={true}>Yes</option>
                                <option value={false}>No</option>
                              </select>
                            </div>
                          </div>
                          <div className="col-lg-6">
                            <div className="form-group">
                              <label>Do you have a insurance?</label>
                              <select
                                name="has_insurance"
                                onChange={this.handleChange.bind(
                                  this,
                                  'has_insurance',
                                )}
                                value={this.state.fields['has_insurance']}
                                className="form-select form-select-lg mb-3"
                                aria-label=".form-select-lg example"
                                // required
                              >
                                <option selected>Select Flag</option>
                                <option value={true}>Yes</option>
                                <option value={false}>No</option>
                              </select>
                            </div>
                          </div>
                          <div className="col-lg-6">
                            <div className="form-group">
                              <label>
                                Are you in ENDS (E-Commerce National Delivery
                                Solution)?
                              </label>
                              <select
                                name="is_ends"
                                onChange={this.handleChange.bind(
                                  this,
                                  'is_ends',
                                )}
                                value={this.state.fields['is_ends']}
                                className="form-select form-select-lg mb-3"
                                aria-label=".form-select-lg example"
                                // required
                              >
                                <option selected>Select Flag</option>
                                <option value={true}>Yes</option>
                                <option value={false}>No</option>
                              </select>
                            </div>
                          </div>
                          <div className="col-lg-6">
                            <div className="form-group">
                              <label>What is your Primary Vehicle Type?</label>
                              <select
                                name="vehicle_type"
                                onChange={this.handleChange.bind(
                                  this,
                                  'vehicle_type',
                                )}
                                value={this.state.fields['vehicle_type']}
                                className="form-select form-select-lg mb-3"
                                aria-label=".form-select-lg example"
                                // required
                              >
                                <option selected>None</option>
                                <option value="Car">Car</option>
                                <option value="MotorCycle">MotorCycle</option>
                                <option value="Truck">Truck </option>
                                <option value="Van">Van</option>
                              </select>
                            </div>
                          </div>
                          {/* <div className="col-lg-6"> */}
                          {/* <div className="form-group">
                              <label>
                                What is your Secondary Vehicle Type?
                              </label>
                              <select
                                name="vehicle_type_secondary"
                                onChange={this.handleChange.bind(
                                  this,
                                  "vehicle_type_secondary"
                                )}
                                value={
                                  this.state.fields["vehicle_type_secondary"]
                                }
                                className="form-select form-select-lg mb-3"
                                aria-label=".form-select-lg example"
                                // required
                              >
                                <option selected>None</option>
                                <option value="Car">Car</option>
                                <option value="MotorCycle">MotorCycle</option>
                                <option value="Truck">Truck </option>
                                <option value="Van">Van</option>
                              </select>
                            </div> */}
                          {/* </div> */}
                          <div className="col-lg-6">
                            <div className="form-group">
                              <label>
                                Have you ever been convicted of a crime which
                                has resulted in jail time?
                              </label>
                              <select
                                name="involved_in_crime"
                                onChange={this.handleChange.bind(
                                  this,
                                  'involved_in_crime',
                                )}
                                value={this.state.fields['involved_in_crime']}
                                className="form-select form-select-lg mb-3"
                                aria-label=".form-select-lg example"
                                // required
                              >
                                <option selected>Select Flag</option>
                                <option value={true}>Yes</option>
                                <option value={false}>No</option>
                              </select>
                            </div>
                          </div>
                          {/* <div className="col-lg-6"> */}
                          {/* <div className="form-group">
                              <label>
                                Have you ever been involved in any traffic
                                infraction?
                              </label>
                              <select
                                name="has_involved_in_trafic_infraction"
                                onChange={this.handleChange.bind(
                                  this,
                                  "has_involved_in_trafic_infraction"
                                )}
                                value={
                                  this.state.fields[
                                    "has_involved_in_trafic_infraction"
                                  ]
                                }
                                className="form-select form-select-lg mb-3"
                                aria-label=".form-select-lg example"
                                // required
                              >
                                <option selected>Select Flag</option>
                                <option value={true}>Yes</option>
                                <option value={false}>No</option>
                              </select>
                            </div> */}
                          {/* </div> */}
                          {/* <div className="col-lg-6"> */}
                          {/* <div className="form-group">
                              <label>What is your driving period?</label>
                              <input
                                type="text"
                                name="driving_period"
                                placeholder="Years or Months of driving experience?"
                                onChange={this.handleChange.bind(
                                  this,
                                  "driving_period"
                                )}
                                value={this.state.fields["driving_period"]}
                                // required
                              />
                            </div> */}
                          {/* </div> */}
                          <div className="col-lg-6">
                            <div className="form-group">
                              <label>What days do you intend to work?</label>
                              <MultiSelect
                                options={workdays_options}
                                value={this.state.workdays_selected}
                                onSelect={this.workdays_setSelected}
                                onRemove={this.workdays_setSelected}
                                displayValue="label"
                                // onChange={this.handleChange.bind(
                                //   this,
                                //   "work_days"
                                // )}
                              />
                            </div>
                          </div>
                          {/* <div className="col-lg-6">
                            <div className="form-group">
                              <label>What days are you willing to work?</label>
                              <DropdownMultiselect
                                placeholder="day?"
                                options={workdays_options}
                                name="work days"
                              />
                            </div>
                          </div> */}
                          {/* <div >
                            <label>What days are  you willing to work?</label>
                      
                              <select
                              className="select" 
                              multiple data-mdb-placeholder="Example placeholder" 
                              multiple
                                name="parish"
                                onChange={this.handleChange.bind(
                                  this,
                                  "parish"
                                )}
                                value={this.state.fields["parish"]}
                        
                               
                                // required
                              >
                                <option selected>Select Parish</option>
                                <option value="1">Sunday</option>
                                <option value="2">Monday</option>
                                <option value="3">Tuesday</option>
                                <option value="4">Wednesday</option>
                                <option value="5">Thursday</option>
                                <option value="5">Friday</option>
                                <option value="5">Saturday</option>
                              </select>
                          
                          </div> */}
                          {/* <div className="col-lg-6">
                            <div className="form-group">
                              <label>Available work hours?</label>
                              <DropdownMultiselect
                                placeholder="work hours?"
                                options={workhours_options}
                                name="countries"
                              />
                            </div>
                          </div> */}
                          <div className="col-lg-6">
                            <div className="form-group">
                              <label>Intended work hours</label>
                              <MultiSelect
                                options={workhours_options}
                                value={this.state.workhours_selected}
                                onSelect={this.workhours_setSelected}
                                onRemove={this.workhours_setSelected}
                                displayValue="label"
                                // onChange={this.handleChange.bind(
                                //   this,
                                //   "work_hours"
                                // )}
                              />
                            </div>
                          </div>
                          {/* <div className="col-lg-6"> */}
                          {/* <div className="form-group">
                              <label>
                                How many hours do you want to work a week?
                              </label>
                              <input
                                type="text"
                                name="weekly_availability"
                                placeholder="Hours available to work a week"
                                onChange={this.handleChange.bind(
                                  this,
                                  "weekly_availability"
                                )}
                                value={this.state.fields["weekly_availability"]}
                                // required
                              />
                            </div> */}
                          {/* </div> */}
                          <div className="col-lg-6">
                            <div className="form-group">
                              <label>When can you start?</label>
                              <input
                                type="date"
                                name="start_time"
                                placeholder="Start time"
                                onChange={this.handleChange.bind(
                                  this,
                                  'start_time',
                                )}
                                value={this.state.fields['start_time']}
                                // required
                              />
                            </div>
                          </div>
                          {/* <div className="col-lg-6"> */}
                          {/* <div className="form-group">
                              <label>When can you finish?</label>
                              <input
                                type="date"
                                name="completion_time"
                                placeholder="Completion time"
                                onChange={this.handleChange.bind(
                                  this,
                                  "completion_time"
                                )}
                                value={this.state.fields["completion_time"]}
                                // required
                              />
                            </div> */}
                          {/* </div> */}
                          <div className="col-lg-6">
                            <div className="form-group">
                              <label>Do you have a smartphone?</label>
                              <select
                                name="has_smart_phone"
                                onChange={this.handleChange.bind(
                                  this,
                                  'has_smart_phone',
                                )}
                                value={this.state.fields['has_smart_phone']}
                                className="form-select form-select-lg mb-3"
                                aria-label=".form-select-lg example"
                                // required
                              >
                                <option selected>Select Flag</option>
                                <option value={true}>Yes</option>
                                <option value={false}>No</option>
                              </select>
                            </div>
                          </div>
                          <div className="col-lg-6">
                            <div className="form-group">
                              <label>
                                What type of smartphone do you have?
                              </label>
                              <input
                                type="text"
                                name="smart_phone_type"
                                placeholder="Smart Phone Type"
                                onChange={this.handleChange.bind(
                                  this,
                                  'smart_phone_type',
                                )}
                                value={this.state.fields['smart_phone_type']}
                                // required
                              />
                            </div>
                          </div>
                          <div className="col-lg-6">
                            <div className="form-group">
                              <label>Do you have bank account?</label>
                              <select
                                name="use_online_banking"
                                onChange={this.handleChange.bind(
                                  this,
                                  'use_online_banking',
                                )}
                                value={this.state.fields['use_online_banking']}
                                className="form-select form-select-lg mb-3"
                                aria-label=".form-select-lg example"
                                // required
                              >
                                <option selected>Select Flag</option>
                                <option value={true}>Yes</option>
                                <option value={false}>No</option>
                              </select>
                            </div>
                          </div>
                          <div className="col-lg-6">
                            <div className="form-group">
                              <label>Do you have a Bill Express account?</label>
                              <select
                                name="has_bill_express_account"
                                onChange={this.handleChange.bind(
                                  this,
                                  'has_bill_express_account',
                                )}
                                value={
                                  this.state.fields['has_bill_express_account']
                                }
                                className="form-select form-select-lg mb-3"
                                aria-label=".form-select-lg example"
                                // required
                              >
                                <option selected>Select Flag</option>
                                <option value={true}>Yes</option>
                                <option value={false}>No</option>
                              </select>
                            </div>
                          </div>
                          <div className="col-lg-6">
                            <div className="form-group">
                              <label>Reference Name</label>
                              <input
                                type="text"
                                name="reference_name"
                                placeholder="Reference name"
                                onChange={this.handleChange.bind(
                                  this,
                                  'reference_name',
                                )}
                                value={this.state.fields['reference_name']}
                                // required
                              />
                            </div>
                          </div>
                          <div className="col-lg-6">
                            <div className="form-group">
                              <label>Reference phone number</label>
                              <input
                                type="text"
                                name="reference_phone"
                                placeholder="Reference phone number"
                                onChange={this.handleChange.bind(
                                  this,
                                  'reference_phone',
                                )}
                                value={this.state.fields['reference_phone']}
                                // required
                              />
                            </div>
                          </div>
                          <div className="col-lg-6">
                            <div className="form-group">
                              <label>Emergency Contact name</label>
                              <input
                                type="text"
                                name="emergency_contact_name"
                                placeholder="Emergency contact name"
                                onChange={this.handleChange.bind(
                                  this,
                                  'emergency_contact_name',
                                )}
                                value={
                                  this.state.fields['emergency_contact_name']
                                }
                                // required
                              />
                            </div>
                          </div>
                          <div className="col-lg-6">
                            <div className="form-group">
                              <label>Emergency Contact phone number</label>
                              <input
                                type="text"
                                name="emergency_contact_phone"
                                placeholder="Emergency Contact phone number"
                                onChange={this.handleChange.bind(
                                  this,
                                  'emergency_contact_phone',
                                )}
                                value={
                                  this.state.fields['emergency_contact_phone']
                                }
                                // required
                              />
                            </div>
                          </div>

                          <div className="col-lg-12">
                            <div className="form-check">
                              <input
                                className="form-check-input"
                                type="checkbox"
                                onChange={(e) => {
                                  e.preventDefault()
                                  this.handleisIndependentAgreementCheck1(
                                    !this.state.isIndependentAgreementCheck1,
                                  )
                                }}
                                value={this.state.isIndependentAgreementCheck1}
                                id="flexCheckDefault"
                                checked={
                                  this.state.isIndependentAgreementCheck1
                                }
                              />
                              <label
                                className="form-check-label"
                                htmlFor="flexCheckDefault"
                              >
                                I acknowledge and understand that I am an
                                Independent <br /> Contractor and not an
                                EMPLOYEE of <br />
                                Courier Driva Limited, <br />
                                Road Jockey JA or Road Jockey LLC
                              </label>
                            </div>
                          </div>

                          <div className="col-lg-12 mt-5">
                            <div className="form-check">
                              <input
                                className="form-check-input"
                                type="checkbox"
                                onChange={(e) => {
                                  e.preventDefault()
                                  this.handleisIndependentAgreementCheck2(
                                    !this.state.isIndependentAgreementCheck2,
                                  )
                                }}
                                value={this.state.isIndependentAgreementCheck2}
                                id="flexCheckChecked"
                                checked={
                                  this.state.isIndependentAgreementCheck2
                                }
                              />
                              <label
                                className="form-check-label"
                                htmlFor="flexCheckChecked"
                              >
                                I acknowledge that Courier Driva Limited,
                                <br /> Road Jockey JA,
                                <br /> Road Jockey LLC, <br />
                                their partners and customers cannot be held
                                liable for any incidents
                                <br /> that happen during the course of you
                                executing a delivery <br />
                                on behalf of the Road Jockey App.
                              </label>
                            </div>
                          </div>
                          <div className="col-lg-12 mt-4">
                            {this.state.isIndependentAgreementCheck1 &&
                            this.state.isIndependentAgreementCheck2 ? (
                              <button
                                className="primary-btn"
                                onClick={this.continue}
                              >
                                Next
                              </button>
                            ) : (
                              <button
                                className="btn secondary-btn"
                                onClick={this.alertAgreement}
                              >
                                Next
                              </button>
                            )}
                          </div>
                        </div>
                      </form>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </section>
        </div>
      </>
    )
  }
}

export default WorkDetails
